export const toTableRowItems = (items: DSDLCProducts[]) =>
  items.map((item: DSDLCProducts) => ({
    shopName: item.shopName || '',
    shopCode: item.shopCode || '',
    shopType: item.shopType || '',
    prodCode: item.prodCode || '',
    ubCode: item.ubCode || '',
    sfaCode: item.sfaCode || '',
    famCode: item.famCode || '',
    rayCode: item.rayCode || '',
    deleted: item.deleted || false
  }))
